import {
  Component, OnDestroy, OnInit
} from '@angular/core';
import {combineAll, distinctUntilChanged, takeUntil} from "rxjs/operators";
import {combineLatest, Subject} from "rxjs";
import {login} from "@iw-shared/store/actions/authentication.action";
import {Store} from "@ngrx/store";
import {AppState} from "@iw-shared/store/state/app.state";
import {Router} from "@angular/router";
import {FormHandler} from "@iw-shared/form/models/form-handler";

@Component({
  selector: 'page-authentication-login',
  templateUrl: './page-authentication-login.component.html',
  styleUrls: ['./page-authentication-login.component.scss']
})
export class PageAuthenticationLoginComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  formHandler: FormHandler = new FormHandler();

  constructor(private store: Store<AppState>, private router: Router) {

  }

  ngOnInit(): void {
    combineLatest([
      this.store.select(state => state.authentication),
      this.store.select(state => state.storage)
    ]).pipe(
      takeUntil(this.ngUnsubscribe),
      distinctUntilChanged(),
    ).subscribe(([authentication, storage]) => {
      if (authentication.isLoading) {
        this.formHandler.setFormStatus({ formStatus: 'loading' });
      } else {
        setTimeout(() => {
          this.formHandler.setFormStatus({ formStatus: null });
        }, 5000);
      }

      if (authentication.errorMsg) {
        this.formHandler.setFormStatus({ formStatus: 'submitForm' });
        this.formHandler.setFormError(
          {
            message: '',
            code: '',
            input: [
              { key: '', error: authentication.errorMsg }
            ]
          }
        );
      }

      if (authentication.success &&
        storage.userId) {
        this.formHandler.setFormStatus({ formStatus: 'success' , resetStatusAfterTimeoutTo: null, callbackAfterTimeout: () => {
            console.log(storage.entryPoint);
          if(storage.entryPoint){
            console.log(storage.entryPoint);
            this.router.navigate([storage.entryPoint]).then();
            return;

          }
            this.router.navigate(['/shop/dashboard']).then();
        }});
      }
    });


  }

  setLogin(params: { username: string, password: string }) {
    this.store.dispatch(login({
      username: params.username,
      password: params.password,
      endpoint: 'admin'
    }));
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}

